var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAgentInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.97852,
    width: 34,
    height: 33,
    rx: 5.5,
    stroke: "#8C8C8C",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7054 14.7702C15.4543 14.6095 19.0866 14.6412 19.9251 14.7517C20.9209 14.883 21.5787 15.5362 21.506 16.548L19.7192 25.504C19.9889 26.538 20.7558 26.5899 21.667 26.2414C22.0824 26.0825 22.6175 25.3925 22.9541 26.0259C23.2573 26.5964 21.9752 27.4729 21.523 27.7138C19.4445 28.8214 15.6403 29.0327 14.908 26.2344C14.9778 23.1906 15.8215 20.1847 16.2509 17.1698C16.0922 15.5436 13.5494 16.9169 14.0702 15.1779C14.2241 14.9856 14.461 14.8227 14.7054 14.7702Z",
    fill: "#8C8C8C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1269 13.4864C20.5464 13.4864 21.6972 12.3654 21.6972 10.9825C21.6972 9.59958 20.5464 8.47852 19.1269 8.47852C17.7074 8.47852 16.5566 9.59958 16.5566 10.9825C16.5566 12.3654 17.7074 13.4864 19.1269 13.4864Z",
    fill: "#8C8C8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgentInfo);
export default __webpack_public_path__ + "static/media/agent-info.6c01d5884190718d95d3f9ccc1d477c0.svg";
export { ForwardRef as ReactComponent };